// ViewSwitch (drawing v2.6, `.seg`; reference section 7): a segmented switch
// for the same data another way (List / Board, Day / Week / Month). Items
// 36 tall on a track with radius 10; 44 under 1024. Switching never saves:
// "Make Board my default" is a separate button, with a confirmation and Undo.

import type { ReactNode } from "react";
import { cx } from "./cx";

export interface ViewOption<T extends string> {
  value: T;
  label: ReactNode;
  hint?: ReactNode;
}

export function ViewSwitch<T extends string>({ options, value, onChange, label, className }: { options: ViewOption<T>[]; value: T; onChange: (v: T) => void; label: string; className?: string }) {
  return (
    <div className={cx("pg-seg", className)} role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o.value} type="button" className={cx("pg-seg__item", o.value === value && "is-on")} aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
          {o.label}
          {o.hint && <small>{o.hint}</small>}
        </button>
      ))}
    </div>
  );
}
